import { Typography, Stack } from '@mui/material';
import type { BackupPolicyType, ResourceType } from '@repo/api-gw-sdk';
import Image, { type StaticImageData } from 'next/image';
import type { ReactNode } from 'react';

import { ResourceTypes } from '@/data/inventory/resourceTypes';

import AllExcluded from '../../../../../../../public/statics/images/illustrations/resource-selection/all_excluded.png';
import AllIncluded from '../../../../../../../public/statics/images/illustrations/resource-selection/all_included.png';
import { isPitrPolicyType } from '../../backupPoliciesTypes';

const DynamicResourcesEmptyState = ({
  title,
  description,
  illustration,
  alt,
  size: size,
}: {
  title: ReactNode;
  description?: string;
  illustration: StaticImageData;
  alt: string;
  size: 'small' | 'large';
}) => {
  return (
    <Stack
      sx={{
        gap: size === 'small' ? '24px' : '40px',
        marginX: '40px',
        alignItems: 'center',
        width: size === 'small' ? '320px' : '480px',
        alignSelf: 'center',
        justifySelf: 'center',
      }}
    >
      <Image
        alt={alt}
        height={size === 'small' ? 60 : 240}
        width={size === 'small' ? 60 : 240}
        src={illustration}
      />
      <Stack
        sx={{
          gap: size === 'small' ? '8px' : '12px',
          alignItems: 'center',
        }}
      >
        {typeof title === 'string' ? (
          <Typography variant={size === 'small' ? 'subtitle1' : 'h3'}>
            {title}
          </Typography>
        ) : (
          title
        )}
        {description && (
          <Typography
            variant='body1'
            sx={{
              textAlign: 'center',
              width: '320px',
            }}
          >
            {description}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

export const DynamicResourcesAllIncluded = ({
  size = 'large',
  description,
  selectedResourceTypes,
  policyType,
}: {
  size?: 'small' | 'large';
  description?: string;
  selectedResourceTypes?: ResourceType[];
  policyType?: BackupPolicyType;
}) => {
  return (
    <DynamicResourcesEmptyState
      title={`All ${selectedResourceTypes && isPitrPolicyType(policyType) ? selectedResourceTypes?.map((type) => ResourceTypes[type].displayName).join(', ') : ''} resources are included`}
      alt='All resources are included'
      description={description}
      illustration={AllIncluded}
      size={size}
    />
  );
};

export const DynamicResourcesAllExcluded = ({
  size = 'large',
  description,
}: {
  size?: 'small' | 'large';
  description: string;
}) => {
  return (
    <DynamicResourcesEmptyState
      title='All resources are excluded'
      alt='All resources are excluded'
      description={description}
      illustration={AllExcluded}
      size={size}
    />
  );
};
